module.exports = __webpack_public_path__ + "img/start_orange2.b3079e3e.png";